<span
  [class]="{'highlightedRed': showTimeOut}"
  [innerText]="(timeRemaining$ | async) | timeSpent: '[d] days + [h]h:[m]m' : '' : true : true">
</span>
